import { render, staticRenderFns } from "./PayerPropertyTypeDropdown.vue?vue&type=template&id=3cbbd01a&scoped=true"
import script from "./PayerPropertyTypeDropdown.vue?vue&type=script&lang=js"
export * from "./PayerPropertyTypeDropdown.vue?vue&type=script&lang=js"
import style0 from "./PayerPropertyTypeDropdown.vue?vue&type=style&index=0&id=3cbbd01a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbbd01a",
  null
  
)

export default component.exports